const track = {
  bind(el, binding) {
    let arg = binding.arg || "click"
    if (binding.value) {
      if (arg === "click") {
        el.addEventListener("click", () => {
          if (binding.value.entrance) {
            binding.value.entrance = document.title
          }
          sensors.track("register_button_click", binding.value)
        })
      }
    }
  },
}

export default track



// WEBPACK FOOTER //
// ./src/common/directives/track.js